export const DEFAULT_DISCOUNT_ROLLOVER_PERCENT = 50;
